import '../styles/Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-wrapper">
        <div className='footer-text'>
            © 2023-{currentYear} Bogdan Marić Developer. All rights reserved.
        </div>
    </footer>
  );
}

export default Footer;
